// src/hooks/useDefaultPlan.ts

import { useQuery } from "@tanstack/react-query";
import { PetUnderwriterType } from "@spotpetinsurance/spot-types/entities/PetQuote";
import { DefaultPlanResponse } from "../utils/QuoteAPI";
import { QuoteAPI } from "../utils/QuoteAPI";

export const useDefaultPlan = (underwriter?: PetUnderwriterType, priorityCode?: string) => {
    // Normalize priority code to match server-side behavior
    const normalizedPriorityCode = priorityCode?.toLowerCase();

    const defaultPlanQuery = useQuery({
        queryKey: ["defaultPlan", underwriter, normalizedPriorityCode], // Use normalized key
        queryFn: async (): Promise<DefaultPlanResponse> => {
            // This should rarely run since data is prefetched
            console.warn("useDefaultPlan: Making unexpected API call - data should be prefetched");
            if (!underwriter) return {};

            const quoteApi = new QuoteAPI(underwriter);
            return quoteApi.getDefaultPlan(normalizedPriorityCode || undefined);
        },
        enabled: !!underwriter,
        staleTime: Infinity,
        retry: 1 // Only retry once since we have fallbacks
    });

    return {
        defaultPlan: defaultPlanQuery.data,
        isDefaultPlanLoading: defaultPlanQuery.isFetching,
        defaultPlanError: defaultPlanQuery.error
    };
};
